import React from 'react'
import pic1 from '../assets/pic1.svg'
import pic2 from  '../assets/pic2.svg'

function Logo() {
  return (
    <div className='md:w-7/12 sm:w-3/4 grid md:grid-cols-6 sm:grid-cols-4 mx-auto gap-8 md:mt-36 mb-12 sm:mt-0'>
        <img src={pic1} alt='' className='md:w-2/3 justify-self-center sm:w-2/3'></img>
        <img src={pic2} alt='' className='md:w-2/3 justify-self-center sm:w-2/3'></img>
        <img src={pic1} alt='' className='md:w-2/3 justify-self-center sm:w-2/3'></img>
        <img src={pic2} alt='' className='md:w-2/3 justify-self-center sm:w-2/3'></img>
        <img src={pic1} alt='' className='sm:hidden md:block md:w-2/3 justify-self-center sm:w-2/3'></img>
        <img src={pic2} alt='' className='sm:hidden md:block md:w-2/3 justify-self-center sm:w-2/3'></img>
    </div>
  )
}

export default Logo
